export default {
    localeName: "en",
    common: {
        done: "Done",
        record: "Record",
        activate: "Activate",
        evaluate: "Evaluate",
        add: "Add",
        create: "Create",
        detail: "Detail",
        admin: "Administrator",
        manager: "Manager",
        socialWorker: "Social worker",
        worker: "Social worker",
        volunteer: "Volunteer",
        save: "Save",
        month: "Month",
        week: "Week",
        yes: "Yes",
        no: "No",
        active: "Active",
        inactive: "Inactive",
        edit: "Edit",
        close: "Close",
        clear: "Clear",
        delete: "Delete",
        search: "Search...",
        searchHint: "Type a search phrase to begin your search ...",
        change: "Change",
        cancel: "Cancel",
        noRecords: "No records were found.",
        deleteItemMessage: "Are you sure you want to delete this item?",
        elationship: "Relationship",
        rowsPerPage: "Rows per page",
        clearFilters: "Clear filters",
        paidTask: "Paid care",
        paidTasks: "Paid care",
        freeTask: "Free care",
        back: "Back",
        all: "All",
        upload: "Upload",
        download: "Download",
        openInNewTab: "Open in new tab",
        confirm: "Confirm",
        show: "Show",
        name: "Name",
        reload: "Reload"
    },
    validation: {
        thisFieldIsRequired: "This field is required.",
        wrongTimeFormat: "Please enter the valid time format."
    },
    days: {
        mo: "Mon",
        tu: "Tue",
        we: "Wed",
        th: "Thu",
        fr: "Fri",
        sa: "Sat",
        su: "Sun"
    },
    components: {
        chooseClient: "Choose client",
        chooseDistrict: "Choose district",
        chooseTown: "Choose town",
        chooseSocialWorker: "Choose worker",
        chooseMainCareProvider: "Choose main care provider",
        chooseOtherCareProvider: "Choose other care provider",
        chooseState: "Choose state",
        chooseAccountType: "Choose account type",
        chooseCatalogItemType: "Choose task type",
        choosePaymentMethod: "Choose payment method",
        dateSince: "Date since",
        dateUntil: "Date until",
        export: "Export",
        startExport: "Start export to Excel",
        district: "District",
        town: "Town",
        socialWorkers: "Care providers",
        unsavedChanges: "You have unsaved changes",
        unsavedChangesText: "We have registered unsaved changes. Do you want to save them before closing?",
        saveChanges: "Save changes",
        closeWithoutSave: "Close without save"
    },
    menu: {
        dashboard: 'Dashboard',
        workTasks: "Tasks",
        newWorkTasks: "Client rules",
        visits: "Visit rules",
        clientsEvaluation: "Clients Evaluation",
        statements: "Statements",
        clients: "Clients",
        cloud: "Files",
        reports: "Reports",
        settings: "Settings"
    },
    authentification: {
        signIn: "Sign in",
        signUp: "Sign up",
        registration: "Sign up",
        passwordRecovery: "Password recovery",
        createAccount: "Create account",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        phoneNumber: "Phone number",
        registeredEmail: "Registered email",
        password: "Password",
        passwordAgain: "Password again",
        newPassword: "New password",
        newPasswordAgain: "New password again",
        weWillSendYouRecoveryEmail: "We will send you a password reset link to the registration email.",
        requestPasswordReset: "Request password reset",
        changePassword: "Change password",
        goToSignIn: "Go to Sign in",
        toast: {
            passwordRecovered: "Password recovered successfully",
            passwordRecoveredText: "Password recovered successfully, you can log in now.",
            passwordNotRecovered: "Failed to reset password",
            passwordNotRecoveredText: "An error occurred while resetting the password. Please check the token and try again.",
            userNotFound: "User not found",
            userNotFoundText: "The user with the specified email was not found. Please try again.",
            passwordRecoveryRequestSent: "Password reset request processed successfully",
            passwordRecoveryRequestSentText: "A recovery confirmation link has been sent to your email address."
        },
        registrationWasSuccessful: "Registration has been completed. An activation e-mail has been sent to your e-mail address.",
        activationLinkVerified: "Activation link verified successfully. You can log in now.",
        verifyingActivationLink: "Verifying activation link ...",
        activationLinkFailed: "Activation link failed to verify.",
        enteredPasswordsMustMatch: "Entered passwords must match.",
        invalidLength: "The password must be at least 6 characters long.",
        errors: {
            signInFailed: "Couldn't log in. Please check your login details.",
            duplicateUserName: "An account with this email address already exists.",
            signUpError: "An error occurred while sign up."
        },
        twoFactor: {
            enterCode: "Enter your SMS code:",
            SMSSent: "We have sent an SMS with the code to your telephone number.",
            notReceivedSMS: "Did you miss the code?",
            sendAgain: "Send SMS again"
        }
    },
    dashboard: {
        todayPlan: "Today's plan",
        today: "Today",
        todayWorkTaskCount: "task count",
        todayClientCount: "client count",
        todayNewClientCount: "new clients",
        todayEvaluationCount: "new evaluations",
        todayNewPaidTaskCount: "new paid tasks",
        todayFreeTaskCount: "new wishes",
        workTasks: "Tasks",
        clientEvalutions: "Client task evaluations",
        newClients: "New clients",
        newTasks: "New tasks",
        manager: "Manager",
        call: "Call"
    },
    workTasks: {
        showTable: "Show table",
        showKanban: "Show columns",
        addUnplannedTask: "Add an unscheduled task",
        notApproved: "Not approved",
        other: "Other",
        done: "Done",
        finished: "Finished",
        workTaskCount: "Task count",
        createWish: "Create wish"
    },
    newWorkTasks: {
        table: {
            headers: {
                client: "Client",
                district: "District",
                town: "Town",
                newWorkTask: "New work task",
                mainCareProvider: "Main care provider",
                phoneNumber: "Phone number",
                status: "Status"
            }
        },
        state: {
            active: "Active",
            new: "New"
        },
        buttons: {
            activate: "Activate",
            detail: "Detail"
        }
    },
    clientsEvaluation: {
        table: {
            headers: {
                client: "Client",
                district: "District",
                town: "Town",
                address: "Address",
                mainCareProvider: "Main care provider",
                phoneNumber: "Phone number",
                status: "Status",
                date: "Date"
            }
        },
        state: {
            active: "Active",
            new: "New"
        },
        buttons: {
            evaluate: "Evaluate",
            detail: "Detail"
        },
        planned: "Planned",
        done: "Done"
    },
    statements: {
        columnClient: "Client",
        columnSocialWorker: "Social worker",
        columnTask: "Task",
        columnPricePerUnit: "Price per unit",
        columnDate: "Date",
        columnAmount: "Amount",
        columnPrice: "Price",
        columnPaymentMethod: "Payment method",
        columnDistrict: "District",
        columnTown: "Town",
        newItem: "New record"
    },
    clients: {
        columnName: "Name",
        columnDistrict: "District",
        columnTown: "Town",
        columnMainCareProvider: "Main social worker",
        columnPhoneNumber: "Phone number",
        columnEmail: "E-mail",
        columnState: "State",
        columnAddress: "Address",
        addClient: "Add client",
        clientCount: "Client count"
    },
    client: {
        menu: {
            general: "General",
            visitPlan: "Visit plan",
            information: "Medical information",
            rules: "Provided care",
            statements: "Statements",
            taskEvaluations: "Task evaluations",
            evaluations: "Client evaluations",
            needs: "Needs",
            socialInquiries: "Social inquiries",
            comments: "Daily records",
            files: "Files",
            interest: "Interest"
        },
        general: {
            firstName: "Firstname",
            lastName: "Lastname",
            startDate: "Initiation of care",
            endDate: "Ending of care",
            state: "State",
            district: "District",
            town: "Town",
            entrustedKeys: "Entrusted keys",
            contract: "Contract",
            generatedId: "Client ID",
            personalNumber: "Personal number (ID)",
            phoneNumber: "Phone number",
            email: "E-mail",
            mainCareProvider: "Main care provider",
            importantContacts: "Important contacts",
            deleteClient: "Delete client",
            deleteClientMessage: "Are you sure you want to delete client \"{name}\"?",
            careProviders: "Other care providers",
            paidTasks: "Paid care",
            freeTasks: "Free care"
        },
        information: {
            payments: "Payments",
            accountNumber: "Bank account number",
            secondAccountNumber: "Alternative bank account number",
            paymentVariableSymbol: "Variable symbol",
            careAllowence: "Care allowence",
            street: "Street",
            city: "City",
            floor: "Room / floor",
            zip: "ZIP",
            dateOfBirth: "Birthdate",
            maritalStatus: "Marital status",
            legalCapacity: "Legal capacity",
            levelOfDisability: "Level of disability",
            benefitClaim: "Benefit claim",
            notes: "Notes",
            risk: "Risk",
            reason: "Reason for request",
            howLearnedAboutUs: "How did the person find out about us",
            conditionBeforeStart: "Status before the start of care provision",
            interestDescription: "Additional information about the applicant",
            medicalInfoHeader: "Medical information",
            doctorName: "The doctor's name",
            doctorPhoneNumber: "The doctor's phone",
            hospitalName: "The name of the nursing hospital",
            hospitalAddress: "The address of the nursing hospital",
            medicalProblems: "Medical problems",
            medicalRestrictions: "Medical restrictions",
            incontinence: "Incotinence",
            otherMedicalInformation: "Other medical information",
            insideMobility: "Mobility inside",
            outsideMobility: "Mobility outside"
        },
        rules: {
            regular: "Regular",
            oneTime: "One-time",
            start: "Start",
            end: "End",
            state: "State",
            repetition: "Repetition",
            repeatEvery: "Repeat every",
            preferredTime: "Preferred time",
            nextBusinessDayOnHoliday: "In the case of holidays, plan for the next day provided",
            description: "Description",
            reason: "Reason",
            goal: "Goal",
            desire: "Desire",
            risk: "Risk",
            tools: "Tools",
            deleteRule: "Delete item",
            deleteRuleMessage: "Are you sure you want to delete the item?",
        },
        statements: { },
        evaluations: {
            nextEvaluationDate: "Next evaluation date",
            history: "History",
            evaluate: "Evaluate",
            dateOfEvaluation: "Date of record",
            addEvaluation: "Add evaluation",
            detailOfEvaluation: "Evaluation detail",
            new: "New",
            deleteEvaluation: "Delete evaluation",
            deleteEvaluationMessage: "Are you sure you want to delete evaluation from"
        },
        clientEvaluations: {
            evaluations: "Client evaluations",
            writeEvaluation: "Write a evaluation",
        },
        needs: {
            record: "Record",
            dateOfRecord: "date of record",
            deleteNeed: "Delete needs",
            deleteNeedMessage: "Are you sure you want to delete needs from"
        },
        socialInquiries: {
            record: "Record",
            dateOfRecord: "date of record",
            deleteSocialInquiry: "Delete social inquiry",
            deleteSocialInquiryMessage: "Are you sure you want to delete social inquiry from"
        },
        comments: {
            comments: "Daily records",
            writeComment: "Write a daily record",
        },
    },
    cloud: {
        uploadFile: "Upload file",
        createFolder: "Create folder",
        newFolderName: "Name of new folder",
        addFolder: "Add folder",
        renameFolder: "Rename folder",
        deleteFolder: "Delete folder",
        renameFile: "Rename file",
        deleteFile: "Delete file",
        saveFile: "Save file",
        downloadFile: "Download file",
        createDate: "Create date",
        enterFileName: "Enter the file name...",
        deleteFolderMessage: "Are you sure you want to delete the folder"
    },
    reports: {
        count: "Count of",
        active: "active",
        archived: "archived",
        done: "done",
        new: "new",
        clients: "clients",
        tasks: "paid tasks",
        evaluations: "evaluations",
        managers: "managers",
        socialWorkers: "social workers",
        wishes: "wishes"
    },
    settings: {
        menu: {
            users: "Users",
            catalog: "Catalogue",
            organization: "Organization",
            districts: "Districts",
            needs: "Needs",
            socialInquiries: "Social inquiries"
        },
        accounts: {
            inviteToOrganization: "Invite to organization",
            invite: "Invite",
            deleteInvitation: "Delete invitation",
            deleteInvitationConfimMessage: "Are you sure you want to delete user invitation {email}?",
            deleteUser: "Delete user",
            deleteUserConfirmMessage: "Are you sure you want to delete user {email}?",
            invitations: "Invitations",
            columnName: "Name",
            columnPhoneNumber: "Phone number",
            columnEmail: "E-mail",
            columnAccountType: "Account type",
            columnManager: "Manager",
            columnDistrict: "Main district",
            districts: "Districts",
            removeDistrict: "Remove district",
            addDistrict: "Add district",
            avatar: "Profile photo"
        },
        catalogue: {
            state: "State",
            active: "Active",
            notActive: "Inactive",
            deleteRule: "Delete item",
            deleteRuleMessage: "Are you sure you want to delete the item \"{name}\"?",
            ruleName: "Name of item",
            unit: "Unit of measure",
            price: "Price per unit",
            reportedUnit: "Reported unit of measure",
            description: "Description",
        },
        organization: {
            name: "Organization name",
            street: "Street",
            city: "City",
            zip: "ZIP",
            identificationNumber: "Identification number",
            vat: "VAT",
            accountNumber: "Bank account number",
            repeatHeader: "Repeat settings",
            repeatEvery: "Repeat every",
            organizationIcon: "Organization icon"
        },
        districts: {
            createDistrict: "Create district",
            towns: "Towns",
            district: "District",
            districtName: "District name",
            deleteDistrict: "Delete district",
            deleteDistrictMessage: "Are you sure you want to delete district \"{name}\"?",
            town: "Town",
            townName: "Town name",
            deleteTown: "Delete town",
            deleteTownMessage: "Are you sure you want to delete town \"{name}\"?"
        },
        needs: {
            needItem: "Need item",
            questionText: "Question text",
            deleteNeed: "Delete item",
            deleteNeedMessage: "Are you sure you want to delete item \"{name}\"?"
        },
        socialInquiries: {
            socialInquiryItem: "Social inquiry item",
            questionText: "Question text",
            deleteSocialInquiry: "Delete item",
            deleteSocialInquiryMessage: "Are you sure you want to delete item \"{name}\"?"
        }
    },
    account: {
        header: "User settings",
        firstname: "Firstname",
        lastName: "Lastname",
        phoneNumber: "Phone number",
        twoFactor: "Two-step verification (SMS PIN)",
        email: "E-mail",
        profilePhoto: "Profile image",
        upload: "Upload",
        passwordChange: "Password change",
        oldPassword: "Old password",
        password: "New password",
        passwordAgain: "New password again",
        connectedOrganizations: "Connected organizations",
        disconnectFromOrganization: "Disconnect from organization",
        disconnect: "Disconnect",
        invitations: "Invitations to organization",
        invitationsLabel: "You have the following invitations to join these organizations",
        connectToOrganization: "Join the organization",
        deleteInvitation: "Delete invitation",
        deleteOrganization: "Disconnect from organization",
        deleteOrganizationMessage: "Do you really want to disconnect from the organization {name}?",
        passwordsHasToMatch: "New passwords must match.",
        checkPassword: "The new password could not be saved, please check the passwords.",
        passwordSaved: "The new password has been saved.",
        avatar: "Profile picture",
        createOrganization: "Create organization",
        selectLanguage: "Select language"
    },
    organizationSignUp: {
        organizationSignUp: "Organization Sign Up",
        organizationName: "Organization name",
        identificationNumber: "Identification number",
        vat: "VAT",
        street: "Street",
        postalCode: "Postal code",
        city: "City",
        signUp: "Sign up"
    },
    methods: {
        formatItemCount: (e: any, c: any) => {
            if (e == 1)
                return e.toString().concat(" item");
            return e.toString().concat(" items");
        }
    },
    codebooks: {
        partyState: {
            active: "Active",
            archived: "Archived",
            interested: "New"
        },
        workTaskState: {
            new: "New",
            inactive: "Inactive",
            active: "Active"
        },
        martialStatus: {
            marriedMan: "Married (man)",
            marriedWoman: "Married (woman)",
            divorced: "Divorced",
            single: "Single",
            notSpecified: "Not specified",
            widower: "Widow / Widower"
        },
        legalCapacity: {
            withRestrictions: "With restrictions",
            withoutRestrictions: "Without restrictions"
        },
        levelOfDisability: {
            none: "None",
            ztp: "ZTP",
            ztpp: "ZTP/P"
        },
        paymentMethod: {
            bankAccount: "Bank account",
            cash: "Cash"
        },
        unitsOfMeasure: {
            piece: "Piece",
            pcs: "Pcs",
            minute: "Minute",
            min: "Min",
            hour: "Hour",
            h: "Hrs",
            kilogram: "Kilo",
            kg: "Kg",
            km: "km",
            kilometer: "Kilometer"
        }
    },
    partyVisitPlan: {
        workTasks: "Work tasks",
        addVisitPlan: "Add visit plan",
        editVisitPlan: "Edit visit plan",
        deleteVisitPlan: "Delete visit plan",
        deleteVisitPlanMessage: "Are you sure you want to delete this visit plan?"
    }
}
